import { render } from "./CZAccrualsWater.vue?vue&type=template&id=3bff8b90&scoped=true&ts=true"
import script from "./CZAccrualsWater.vue?vue&type=script&lang=ts"
export * from "./CZAccrualsWater.vue?vue&type=script&lang=ts"

import "./CZAccrualsWater.vue?vue&type=style&index=0&id=3bff8b90&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bff8b90"]])

export default __exports__